import axios from 'axios'
import * as Util from '../util'

const state = {
  results: []
}

const mutations = {
  FETCH (state, locationIds) {
    axios.get(Util.makeGetByIdUrl('/locations/collisions', locationIds)).then(function (response) {
      state.results = response.data
    }).catch(function (error) {
      console.log(error)
    })
  },

  RESET (state) {
    state.results = []
  }
}

const actions = {
  fetch: function ({commit}, locationIds) {
    commit('FETCH', locationIds)
  },

  reset: function ({commit}) {
    commit('RESET')
  }
}

const getters = {
  results: state => state.results
}

export const LocationsCollisions = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/LocationsCollisions.js